import React, { useState, useEffect, useRef } from 'react';
import Video from 'twilio-video';
import styled, { createGlobalStyle } from 'styled-components';
import StyledTappable from '../common/StyledTappable';
import { Text } from '../common/Text';
// import { docEndCall } from '../../services/consults';
import { useDispatch, useSelector } from 'react-redux';
import { resetVideoData } from '../../actions';
import { FaTimes } from 'react-icons/fa';
import Draggable from 'react-draggable';
import waitingRoom from '../../images/VideoCall/wait.png';
import mute from '../../images/VideoCall/mute.svg';
import speakerImg from '../../images/VideoCall/speaker.svg';
import speakerActive from '../../images/VideoCall/speakerActive.svg';
import muteActive from '../../images/VideoCall/muteActive.svg';
import minimize from '../../images/VideoCall/minimize.svg';
import maximize from '../../images/VideoCall/minimize.svg';
import bar1 from '../../images/VideoCall/network1.svg';
import bar2 from '../../images/VideoCall/network2.svg';
import bar3 from '../../images/VideoCall/network3.svg';
import bar4 from '../../images/VideoCall/network4.svg';
import bar5 from '../../images/VideoCall/network5.svg';
import connectGif from '../../images/VideoCall/conn.gif';
import reconnectGif from '../../images/VideoCall/reconn.gif';
import videoOff from '../../images/VideoCall/videoOff.svg';
import videoOn from '../../images/VideoCall/videoOn.svg';
import switchCameraIcon from '../../images/common/camera-flip.svg';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 1px solid #d8d8d8;
  height: 100%;
  width: 100%;
`;

const ConnectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: rgba(47, 47, 47, 0.4);
  backdrop-filter: blur(24.464536666870117px);
  z-index: 1000;
`;

const ConnectingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 271px;
  height: 266px;
  border-radius: 16px;
  background: rgba(31, 31, 31, 0.7);
  backdrop-filter: blur(24.464536666870117px);
  padding: 24px;
`;

const ConnectingGif = styled.img`
  width: 120px;
  height: 115px;
  margin-top: 0px;
`;

const ConnectingText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.274px;
`;

const BadnetworkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: #ea4335;
`;

const TryButton = styled.button`
  display: flex;
  height: 40px;
  width: 210px;
  /* padding: 14px 90px; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 12px;
  background: #fff;
  color: #404041;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-top: 20px;
`;

const ControlsContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  // gap: 60px;
  border-radius: 17.365px 17.365px 0px 0px;
  background: rgba(55, 55, 55, 0.3);
  backdrop-filter: blur(26.55217742919922px);
  z-index: 10001;
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  /* background: rgba(255, 255, 255, 0.20); */
  background: ${(props) =>
    props.speaker || props.mute
      ? 'rgba(255, 255, 255, 0.90)'
      : 'rgba(255, 255, 255, 0.20)'};
  background: ${(props) => props.endCall && '#F83D39'};
  cursor: pointer;
`;

const ControlsImg = styled.img`
  width: 30px;
  height: 30px;
`;

const Minimize = styled.img`
  position: absolute;
  top: 25px;
  right: 25px;
  height: 55px;
  width: 55px;
  cursor: pointer;
`;

const Maximize = styled.img`
  position: absolute;
  top: 20px;
  right: 20px;
  height: 30px;
  width: 30px;
  cursor: pointer;
`;

const NetworkBarContainer = styled.div`
  position: absolute;
  top: 100px;
  right: 65px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const NetworkBar = styled.img`
  width: 30px;
  height: 30px;
`;

const NetworkBarText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.32px;
`;

const RemoteParticipants = styled.video`
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

const LocalParticipants = styled.video`
  height: 100%;
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  transform: ${(props) => (props.isBackCamera ? 'none' : 'scaleX(-1)')};
`;

const RemoteParticipantsImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

const VideoDisabledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  min-height: 100%;
  background: rgba(31, 31, 31, 1);
  border-radius: 8px;
`;

const PatientInitials = styled.p`
  color: #fff;
  font-size: 64px;
  font-style: normal;
  font-weight: 500;
  line-height: 78.581px;
  letter-spacing: 0.77px;
`;

const PoorConnectionContainer = styled.div`
  position: absolute;
  bottom: 140px;
  left: 50%;
  width: 380px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  background: rgba(55, 55, 55, 0.7);
  backdrop-filter: blur(24.464536666870117px);
  z-index: 10001;
  padding: 20px;
  transform: translate(-50%, 0);
`;

const PoorConnectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const PoorConnectionText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.274px;
  margin-right: 50px;
`;

const PipReconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  min-height: 100%;
  background: rgba(31, 31, 31, 1);
  border-radius: 8px;
`;

const DurationTimerContainer = styled.div`
  position: absolute;
  top: 50px;
  left: 20px;
  display: flex;
  flex-direction: column;
  width: 290px;
  z-index: 10005;
`;

const PatientName = styled.p`
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.274px;
`;

const DurationTimer = styled.p`
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.32px;
`;

const AudioMuted = styled.img`
  position: absolute;
  left: 50%;
  bottom: ${(props) => (props.poorConn && !props.minimized ? '30%' : '20%')};
  transform: translate(-50%, 0);
  z-index: 1000;
`;
const GlobalStyle = createGlobalStyle`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const VideoRoom = ({
  roomName,
  token,
  userName,
  profileImg,
  doctorName,
  sessionId,
  authToken,
  history,
  handleFeedback,
  minimizeVideo,
}) => {
  const [room, setRoom] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);
  const [videoRemoteTracks, setVideoRemoteTracks] = useState([]);
  const [audioRemoteTracks, setAudioRemoteTracks] = useState([]);
  const [muteVideo, setMuteVideo] = useState(true);
  const [muteAudio, setMuteAudio] = useState(true);
  const [userConnected, setUserConnected] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [networkQualityLocal, setNetworkQualityLocal] = useState(0);
  const [networkQualityRemote, setNetworkQualityRemote] = useState(0);
  const [connecting, setConnecting] = useState(true);
  const [badNetwork, setBadNetwork] = useState(false);
  const [reconnectingLocal, setReconnectingLocal] = useState(false);
  const [reconnectingRemote, setReconnectingRemote] = useState(false);
  const [localUserConnected, setLocalUserConnected] = useState(false);
  const [callEnded, setCallEnded] = useState(false);
  const [speaker, setSpeaker] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [paused, setPaused] = useState(false);
  const [poorConnectionModal, setPoorConnectionModal] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [localVideoEnabled, setLocalVideoEnabled] = useState(true);
  const [remoteVideoEnabled, setRemoteVideoEnabled] = useState(true);
  const [remoteAudioEnabled, setRemoteAudioEnabled] = useState(true);
  const [permissions, setPermissions] = useState(false);
  const [videoDevices, setVideoDevices] = useState([]);
  const [selectedVideoDevice, setSelectedVideoDevice] = useState(null);
  const [isBackCamera, setIsBackCamera] = useState(false);
  const [isSwitchingCamera, setIsSwitchingCamera] = useState(false);
  let mins = min;
  let secs = sec;

  const videoRef = useRef();
  const audioRef = useRef();
  const videoRemoteRef = useRef();
  const audioRemoteRef = useRef();

  const dispatch = useDispatch();

  console.log(roomName, token, userName, profileImg);

  // Update in your checkPermissionsAndCameras function
  useEffect(() => {
    const checkPermissionsAndCameras = async () => {
      try {
        // Request access to both video and audio devices
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });

        // Permissions granted
        setPermissions(true);

        // Get the active track to determine its properties
        const videoTrack = stream.getVideoTracks()[0];
        const settings = videoTrack.getSettings();

        // Check if the browser provides facingMode information
        const detectedFacingMode = settings.facingMode;
        console.log('Initial camera facingMode:', detectedFacingMode);

        // Now that we have permissions, get camera devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter(
          (device) => device.kind === 'videoinput'
        );
        setVideoDevices(videoInputs);

        // If facingMode is available, use it to determine back camera
        let isInitialCameraBack = false;
        let initialCamera = null;

        if (detectedFacingMode === 'environment') {
          // Currently using back camera based on facingMode
          isInitialCameraBack = true;

          // Find matching device
          initialCamera = videoInputs.find(
            (device) => device.deviceId === videoTrack.getSettings().deviceId
          );
        } else {
          // Try to find a back camera in the list
          const backCamera = videoInputs.find(
            (device) =>
              device.label.toLowerCase().includes('back') ||
              device.label.toLowerCase().includes('environment')
          );

          // For first load, prefer front camera if available
          const frontCamera = videoInputs.find(
            (device) =>
              device.label.toLowerCase().includes('front') ||
              device.label.toLowerCase().includes('user') ||
              (!device.label.toLowerCase().includes('back') &&
                !device.label.toLowerCase().includes('environment'))
          );

          initialCamera =
            frontCamera ||
            backCamera ||
            (videoInputs.length > 0 ? videoInputs[0] : null);

          // Only set as back camera if we're definitely using a back camera
          isInitialCameraBack = initialCamera
            ? initialCamera.label.toLowerCase().includes('back') ||
              initialCamera.label.toLowerCase().includes('environment')
            : false;
        }

        console.log('Initial camera is back camera:', isInitialCameraBack);

        // Update device and camera type state
        setSelectedVideoDevice(initialCamera);
        setIsBackCamera(isInitialCameraBack);

        // Clean up the test stream
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        // Permissions denied
        setPermissions(false);
        console.error('Error getting permissions:', error);
      }
    };

    checkPermissionsAndCameras();
  }, []);

  const toggleCamera = async () => {
    if (videoDevices.length < 2 || isSwitchingCamera) return;

    try {
      // Add iOS detection
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      console.log('Device is iOS:', isIOS);

      // Set switching state early to prevent multiple taps
      setIsSwitchingCamera(true);

      // IMPORTANT: First completely release ALL media resources
      console.log('Stopping all tracks and media streams');

      // 1. Stop any existing tracks in our state
      if (videoTracks.length > 0) {
        console.log(`Stopping ${videoTracks.length} tracked video tracks`);
        videoTracks.forEach((track) => {
          try {
            track.stop();
          } catch (err) {
            console.log('Error stopping track:', err);
          }
        });
      }

      // Determine target camera type (opposite of current)
      const targetIsBackCamera = !isBackCamera;
      console.log(
        `Current camera is ${isBackCamera ? 'back' : 'front'}, switching to ${
          targetIsBackCamera ? 'back' : 'front'
        }`
      );

      // Find a camera that matches our target type
      let nextDevice = null;

      // If switching to back camera, look for one with "back" or "environment" in the name
      if (targetIsBackCamera) {
        nextDevice = videoDevices.find(
          (device) =>
            device.label.toLowerCase().includes('back') ||
            device.label.toLowerCase().includes('environment')
        );
      }
      // If switching to front camera, look for one with "front" or "user" in the name
      // or one without "back" in the name (likely front)
      else {
        nextDevice = videoDevices.find(
          (device) =>
            device.label.toLowerCase().includes('front') ||
            device.label.toLowerCase().includes('user') ||
            (!device.label.toLowerCase().includes('back') &&
              !device.label.toLowerCase().includes('environment'))
        );
      }

      // If we couldn't find a matching camera, get any camera that's not the current one
      if (!nextDevice) {
        console.log(
          "Couldn't find a camera matching desired type, using any alternative camera"
        );
        nextDevice = videoDevices.find(
          (device) => device.deviceId !== selectedVideoDevice?.deviceId
        );
      }

      // If still no device, fallback to first device
      if (!nextDevice && videoDevices.length > 0) {
        nextDevice = videoDevices[0];
      }

      if (!nextDevice) {
        throw new Error('No alternative camera available');
      }

      console.log(`Switching to device: ${nextDevice.label}`);

      // 2. If in a room, properly unpublish all tracks
      if (room) {
        const videoPublications = Array.from(
          room.localParticipant.videoTracks.values()
        );
        if (videoPublications.length > 0) {
          console.log(
            `Unpublishing ${videoPublications.length} tracks from room`
          );
          for (const publication of videoPublications) {
            try {
              await room.localParticipant.unpublishTrack(publication.track);
              publication.track.stop();
            } catch (err) {
              console.log('Error unpublishing track:', err);
            }
          }
        }
      }

      // 3. Clear video ref elements
      if (videoRef.current) {
        console.log('Clearing video reference elements');
        if (videoRef.current.srcObject) {
          try {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
            videoRef.current.srcObject = null;
          } catch (err) {
            console.log('Error clearing srcObject:', err);
          }
        }

        // Remove all child nodes
        while (videoRef.current.firstChild) {
          videoRef.current.removeChild(videoRef.current.firstChild);
        }
      }

      // 4. Force delay to ensure resources are fully released (longer for iOS)
      console.log('Waiting for resources to be released');
      await new Promise((resolve) => setTimeout(resolve, isIOS ? 800 : 500));

      // 5. Additional force-release by requesting a temporary audio-only stream
      try {
        const tempStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        tempStream.getTracks().forEach((track) => track.stop());
      } catch (err) {
        console.log('Audio permission check failed:', err);
      }

      // PHASE 3: CREATE NEW TRACK WITH ROBUST ERROR HANDLING

      // Keep track of the current track we create
      let newTrack = null;

      if (room) {
        // Try multiple approaches to create a track, with proper error handling
        const approaches = [
          // Approach 1: specific deviceId with exact constraint
          async () => {
            console.log('Trying approach 1: deviceId with exact constraint');
            return await Video.createLocalVideoTrack({
              deviceId: { exact: nextDevice.deviceId },
            });
          },

          // Approach 2: facingMode with exact constraint
          async () => {
            console.log('Trying approach 2: facingMode with exact constraint');
            return await Video.createLocalVideoTrack({
              facingMode: {
                exact: targetIsBackCamera ? 'environment' : 'user',
              },
            });
          },

          // Approach 3: deviceId without exact constraint
          async () => {
            console.log('Trying approach 3: deviceId without exact constraint');
            return await Video.createLocalVideoTrack({
              deviceId: nextDevice.deviceId,
            });
          },

          // Approach 4: facingMode without exact constraint
          async () => {
            console.log(
              'Trying approach 4: facingMode without exact constraint'
            );
            return await Video.createLocalVideoTrack({
              facingMode: targetIsBackCamera ? 'environment' : 'user',
            });
          },

          // Approach 5: no constraints
          async () => {
            console.log('Trying approach 5: no specific constraints');
            return await Video.createLocalVideoTrack({});
          },
        ];

        // Try each approach in sequence until one works
        for (const approach of approaches) {
          try {
            newTrack = await approach();
            console.log('Successfully created track with approach');
            break; // Exit the loop if successful
          } catch (err) {
            console.log('Approach failed:', err.message);
            // Continue to next approach
          }
        }

        // If all approaches failed, throw error
        if (!newTrack) {
          throw new Error('All camera access approaches failed');
        }

        // PHASE 4: UPDATE STATE AND PUBLISH TRACK

        // Update device selection
        setSelectedVideoDevice(nextDevice);

        // Don't update camera type state yet - wait until track is attached
        // This prevents the transform flipping before the video changes

        // Publish the new track
        console.log('Publishing new track to room');
        await room.localParticipant.publishTrack(newTrack);

        // Update track state
        setVideoTracks([newTrack]);

        // PHASE 5: ATTACH TO VIDEO ELEMENT

        // Create temporary container for attachment
        const tempDiv = document.createElement('div');
        tempDiv.style.display = 'none';
        document.body.appendChild(tempDiv);

        // Attach track to temp container
        console.log('Attaching track to video element');
        const videoElement = newTrack.attach();
        tempDiv.appendChild(videoElement);

        // Configure video element
        videoElement.setAttribute('data-video-track', 'true');
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'cover';

        // Move to final container after short delay to ensure everything is ready
        setTimeout(
          () => {
            if (videoRef.current) {
              // Clean up any existing elements first
              while (videoRef.current.firstChild) {
                videoRef.current.removeChild(videoRef.current.firstChild);
              }

              // Move element to final container
              videoRef.current.appendChild(videoElement);

              // Remove temp container
              document.body.removeChild(tempDiv);

              // Apply mute state
              if (muteVideo) {
                newTrack.enable();
              } else {
                newTrack.disable();
              }

              // Now update camera type state AFTER the video is attached
              // This ensures transform is applied after new video is showing
              setIsBackCamera(targetIsBackCamera);

              // Finally clear switching state with a delay
              setTimeout(
                () => {
                  setIsSwitchingCamera(false);
                  console.log('Camera switch complete!');
                },
                isIOS ? 300 : 100
              );
            } else {
              setIsSwitchingCamera(false);
            }
          },
          isIOS ? 300 : 150
        );
      } else {
        // Not in a room, just update states
        setSelectedVideoDevice(nextDevice);
        setIsBackCamera(targetIsBackCamera);
        setIsSwitchingCamera(false);
      }
    } catch (error) {
      console.error('Camera switching error:', error);

      // IMPORTANT: Recovery mechanism
      try {
        console.log('Attempting recovery...');
        // Delay to ensure resources are released
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Clear all states to a clean slate
        if (videoRef.current) {
          while (videoRef.current.firstChild) {
            videoRef.current.removeChild(videoRef.current.firstChild);
          }
        }

        // Try to fall back to current camera
        if (room && selectedVideoDevice) {
          const recoveryTrack = await Video.createLocalVideoTrack({
            deviceId: selectedVideoDevice.deviceId,
          });

          room.localParticipant.publishTrack(recoveryTrack);

          // Attach to video element
          const videoElement = recoveryTrack.attach();
          if (videoRef.current) {
            videoRef.current.appendChild(videoElement);
          }

          setVideoTracks([recoveryTrack]);
        }
      } catch (recoveryError) {
        console.error('Recovery failed:', recoveryError);
      }

      alert(`Camera switching error: ${error.message}. Please try again.`);
      setIsSwitchingCamera(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setConnecting(false);
    }, 7000);
  }, []);

  useEffect(() => {
    if (networkQualityLocal > 1) {
      setLocalUserConnected(true);
      setBadNetwork(false);
    }

    if (!localUserConnected && networkQualityLocal <= 1) {
      setBadNetwork(true);
    }

    if (localUserConnected && networkQualityLocal <= 2) {
      setPoorConnectionModal(true);
    }

    if (localUserConnected && networkQualityLocal > 2) {
      setPoorConnectionModal(false);
    }

    if (userConnected && networkQualityRemote <= 0) {
      setPaused(true);
      setReconnectingRemote(true);
    }

    if (userConnected && networkQualityRemote > 0) {
      setPaused(false);
      setReconnectingRemote(false);
    }
  }, [
    networkQualityLocal,
    localUserConnected,
    userConnected,
    networkQualityRemote,
  ]);

  useEffect(() => {
    let timerInterval;

    if (!connecting && userConnected && localUserConnected) {
      if (!paused) {
        timerInterval = setInterval(() => {
          setSeconds((prevSeconds) => {
            if (prevSeconds === 59) {
              setMinutes((prevMinutes) => prevMinutes + 1);
              return 0;
            } else {
              return prevSeconds + 1;
            }
          });
        }, 1000);
      }
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [connecting, userConnected, paused, localUserConnected]);

  useEffect(() => {
    // disconnect call after 1 min (reconnecting)
    let timer;
    if (reconnectingLocal) {
      timer = setTimeout(() => {
        dispatch(resetVideoData());
      }, 42000);
    }
    return () => clearTimeout(timer);
  }, [reconnectingLocal]);

  useEffect(() => {
    // disconnect call after 1 min (reconnecting)
    let timer;
    if (reconnectingRemote) {
      timer = setTimeout(() => {
        dispatch(resetVideoData());
      }, 42000);
    }
    return () => clearTimeout(timer);
  }, [reconnectingRemote]);

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  /*const countUp = () => {
    console.log({ mins, secs });
    if (!mins && !secs) {
      setInterval(() => {
        if (secs >= 60) {
          mins = mins + 1;
          secs = 0;
          setMin(mins);
          setSec(0);
          console.log({ mins });
        } else {
          secs = secs + 1;
          setMin(mins);
          setSec(secs);
          console.log({ secs });
        }
      }, 1000);
    }
  };
  */
  // Connect Video call
  useEffect(() => {
    const monitorNetworkRemote = (networkQualityLevel) => {
      console.log(networkQualityLevel);
      setNetworkQualityRemote((prevNetworkQuality) => {
        return networkQualityLevel;
      });
    };

    const participantConnected = (participant) => {
      console.log({ participant, sid: participant.sid }, 'participant');
      setParticipants(participant);
      roomRemoteParticipants(participant);
      setUserConnected(1);
      // countUp();
      console.log('hit');
      participant.on('networkQualityLevelChanged', monitorNetworkRemote);
    };

    const participantDisconnected = () => {
      setParticipants(null);
      setUserConnected(0);
      setMinimized(false);
    };

    const monitorNetworkLocal = (networkQualityLevel) => {
      console.log(networkQualityLevel);
      setNetworkQualityLocal((prevNetworkQuality) => {
        return networkQualityLevel;
      });
    };

    const reconnectingHandler = () => {
      console.log('hit');
      setPaused(true);
      setReconnectingLocal(true);
    };

    const reconnectedHandler = () => {
      console.log('hit');
      setPaused(false);
      setReconnectingLocal(false);
    };

    console.log(participants);

    Video.connect(token, {
      name: roomName,
      networkQuality: {
        local: 1, // LocalParticipant's Network Quality verbosity [1 - 3]
        remote: 2, // RemoteParticipants' Network Quality verbosity [0 - 3]
      },
      video: selectedVideoDevice
        ? {
            deviceId: { exact: selectedVideoDevice.deviceId }, // Add this to ensure correct camera is used
            facingMode: isBackCamera ? 'environment' : 'user',
          }
        : true,
      audio: true,
    }).then((room) => {
      setRoom(room);
      roomParticipants(room.localParticipant);
      console.log({ room });
      for (let [sid, participant] of room.participants.entries()) {
        console.log({ sid, participant });
        if (sid !== room.localParticipant.sid) {
          participantConnected(participant);
        }
      }
      room.on('participantConnected', participantConnected);
      room.on('participantDisconnected', participantDisconnected);
      room.on('reconnecting', reconnectingHandler);
      room.on('reconnected', reconnectedHandler);
      room.localParticipant.setNetworkQualityConfiguration({
        local: 2,
        remote: 1,
      });
      room.localParticipant.on(
        'networkQualityLevelChanged',
        monitorNetworkLocal
      );
    });

    return () => {
      setRoom((currentRoom) => {
        if (currentRoom && currentRoom.localParticipant.state === 'connected') {
          currentRoom.localParticipant.tracks.forEach(function (
            trackPublication
          ) {
            trackPublication.track.stop();
          });
          currentRoom.disconnect();
          return null;
        } else {
          return currentRoom;
        }
      });
    };
  }, [roomName, token]);
  // local participants
  const roomParticipants = (participant) => {
    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    const trackSubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else if (track.kind === 'audio') {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else if (track.kind === 'audio') {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    const trackDisabled = (track) => {
      console.log(track.kind);
      if (track.kind === 'video') {
        setLocalVideoEnabled(false);
      }
    };

    const trackEnabled = (track) => {
      console.log(track.kind);
      if (track.kind === 'video') {
        setLocalVideoEnabled(true);
      }
    };

    participant.on('trackSubscribed', trackSubscribed);
    participant.on('trackUnsubscribed', trackUnsubscribed);
    participant.on('trackDisabled', trackDisabled);
    participant.on('trackEnabled', trackEnabled);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  };

  useEffect(() => {
    const videoTrack = videoTracks[0];
    console.log(videoTrack);
    console.log(connecting, localUserConnected);
    if (videoTrack && !connecting && localUserConnected) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks, connecting, localUserConnected]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);
  // Remote Participants
  const roomRemoteParticipants = (participant) => {
    console.log({ participant });
    setVideoRemoteTracks(trackpubsToTracks(participant.videoTracks));
    setAudioRemoteTracks(trackpubsToTracks(participant.audioTracks));

    const trackSubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoRemoteTracks((videoRemoteTracks) => [
          ...videoRemoteTracks,
          track,
        ]);
      } else if (track.kind === 'audio') {
        setAudioRemoteTracks((audioRemoteTracks) => [
          ...audioRemoteTracks,
          track,
        ]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoRemoteTracks((videoRemoteTracks) =>
          videoRemoteTracks.filter((v) => v !== track)
        );
      } else if (track.kind === 'audio') {
        setAudioRemoteTracks((audioRemoteTracks) =>
          audioRemoteTracks.filter((a) => a !== track)
        );
      }
    };

    const reconnectingHandler = () => {
      console.log('hit');
      setPaused(true);
      setReconnectingRemote(true);
    };

    const reconnectedHandler = () => {
      console.log('hit');
      setPaused(false);
      setReconnectingRemote(false);
    };

    const trackDisabled = (track) => {
      console.log(track.kind);
      if (track.kind === 'video') {
        setRemoteVideoEnabled(false);
      }
      if (track.kind === 'audio') {
        setRemoteAudioEnabled(false);
      }
    };

    const trackEnabled = (track) => {
      console.log(track.kind);
      if (track.kind === 'video') {
        setRemoteVideoEnabled(true);
      }
      if (track.kind === 'audio') {
        setRemoteAudioEnabled(true);
      }
    };

    participant.on('trackSubscribed', trackSubscribed);
    participant.on('trackUnsubscribed', trackUnsubscribed);
    participant.on('reconnecting', reconnectingHandler);
    participant.on('reconnected', reconnectedHandler);
    participant.on('trackDisabled', trackDisabled);
    participant.on('trackEnabled', trackEnabled);

    return () => {
      setVideoRemoteTracks([]);
      setAudioRemoteTracks([]);
      participant.removeAllListeners();
    };
  };
  useEffect(() => {
    const videoTrack = videoRemoteTracks[0];
    console.log(videoTrack);
    if (videoTrack && !connecting && userConnected) {
      videoTrack.attach(videoRemoteRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoRemoteTracks, connecting, userConnected]);

  useEffect(() => {
    const audioTrack = audioRemoteTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRemoteRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioRemoteTracks]);
  // Handle video call
  const handleMuteVideo = () => {
    if (room) {
      if (muteVideo) {
        room.localParticipant.videoTracks.forEach((publication) => {
          publication.track.disable();
          setMuteVideo(false);
        });
      } else {
        room.localParticipant.videoTracks.forEach((publication) => {
          publication.track.enable();
          setMuteVideo(true);
        });
      }
    }
  };

  const handleMuteAudio = () => {
    if (room) {
      if (muteAudio) {
        room.localParticipant.audioTracks.forEach((publication) => {
          publication.track.disable();
          setMuteAudio(false);
        });
      } else {
        room.localParticipant.audioTracks.forEach((publication) => {
          publication.track.enable();
          setMuteAudio(true);
        });
      }
    }
  };

  const handleDisconnectRoom = () => {
    if (room) {
      room.on('disconnected', (room) => {
        room.localParticipant.tracks.forEach((publication) => {
          const attachedElements = publication.track.detach();
          attachedElements.forEach((element) => element.remove());
        });
      });
      room.disconnect();
      // history.push('/home');
      setCallEnded(true);
      dispatch(resetVideoData(true));
      handleFeedback();
    }
    dispatch(resetVideoData(true));
  };

  const handleTryAgain = () => {
    setConnecting(true);

    setTimeout(() => {
      setConnecting(false);
    }, 7000);
  };

  const handleMinimize = () => {
    minimizeVideo();
    setMinimized((prev) => !prev);
  };

  const extractFirstLetter = (input) => {
    return input.replace(/^(Dr\.?|Dr|Mr\.?|Mr|Mrs\.?|Mrs)\s*/i, '').charAt(0);
  };

  console.log(localUserConnected, userConnected);
  return (
    <OuterContainer>
      {!permissions && (
        <ConnectionContainer>
          <ConnectingContainer>
            <ConnectingGif src={connectGif} />
            <ConnectingText>Permissions Required</ConnectingText>
            <ConnectingText
              style={{
                fontSize: '14px',
                marginTop: '16px',
                lineHeight: '18px',
              }}
            >
              Please enable camera and microphone access to continue.
            </ConnectingText>
          </ConnectingContainer>
        </ConnectionContainer>
      )}
      {permissions && connecting && (
        <ConnectionContainer>
          <ConnectingContainer>
            <ConnectingGif src={connectGif} />
            <ConnectingText>Connecting...</ConnectingText>
            <ConnectingText
              style={{
                fontSize: '14px',
                marginTop: '16px',
                lineHeight: '18px',
              }}
            >
              We are checking your connection
            </ConnectingText>
          </ConnectingContainer>
        </ConnectionContainer>
      )}
      {permissions && !connecting && badNetwork && (
        <ConnectionContainer>
          <ConnectingContainer style={{ padding: '20px' }}>
            <BadnetworkContainer>
              <FaTimes
                style={{ color: '#FFF', height: '25px', width: '25px' }}
              />
            </BadnetworkContainer>
            <ConnectingText style={{ marginTop: '30px' }}>
              Bad Network
            </ConnectingText>
            <ConnectingText
              style={{
                fontSize: '14px',
                marginTop: '20px',
                lineHeight: '18px',
              }}
            >
              Please check your network and try again
            </ConnectingText>
            <TryButton onClick={handleTryAgain}>Try Again</TryButton>
          </ConnectingContainer>
        </ConnectionContainer>
      )}
      {permissions &&
        !connecting &&
        !minimized &&
        !badNetwork &&
        (reconnectingLocal || reconnectingRemote) && (
          <ConnectionContainer>
            <ConnectingContainer>
              <ConnectingGif
                src={reconnectGif}
                style={{ height: '80px', width: '80px' }}
              />
              <ConnectingText style={{ marginTop: '30px' }}>
                Reconnecting...
              </ConnectingText>
              {reconnectingLocal && (
                <ConnectingText
                  style={{
                    fontSize: '14px',
                    marginTop: '20px',
                    lineHeight: '18px',
                  }}
                >
                  Check your connection or try moving for a better signal...
                </ConnectingText>
              )}
              {!reconnectingLocal && reconnectingRemote && (
                <ConnectingText
                  style={{
                    fontSize: '14px',
                    marginTop: '20px',
                    lineHeight: '18px',
                  }}
                >
                  There’s an issue with Doctor’s network please wait till they
                  fix it...
                </ConnectingText>
              )}
            </ConnectingContainer>
          </ConnectionContainer>
        )}
      {!connecting && (
        <Draggable bounds="parent">
          <div
            style={{
              position: 'absolute',
              zIndex: '100000',
              borderRadius: '8px',
              height: !minimized ? '200px' : '0px',
              width: !minimized ? '200px' : '0px',
              right: '4%',
              bottom: '17%',
            }}
          >
            {/* Camera switching overlay */}
            {isSwitchingCamera && (
              <div
                style={{
                  position: 'absolute',
                  zIndex: 10002,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    border: '3px solid #ffffff',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                  }}
                />
              </div>
            )}
            <LocalParticipants
              ref={videoRef}
              height="100%"
              width="100%"
              autoPlay={true}
              muted={true}
              isBackCamera={isBackCamera}
              style={
                !localVideoEnabled ? { display: 'none' } : { width: '100%' }
              }
            />
            {!localVideoEnabled && !minimized && (
              <VideoDisabledContainer>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'var(--primary-button)',
                    borderRadius: '100%',
                    padding: '43px',
                    width: '100px',
                    height: '100px',
                  }}
                >
                  <PatientInitials>
                    {extractFirstLetter(userName).toUpperCase()}
                  </PatientInitials>
                </div>
              </VideoDisabledContainer>
            )}
          </div>
        </Draggable>
      )}
      {!connecting &&
        (userConnected ? (
          <div
            style={{
              position: 'relative',
              minHeight: '100%',
              minWidth: '100%',
              display:
                !minimized &&
                (reconnectingLocal || reconnectingRemote || badNetwork)
                  ? 'none'
                  : 'flex',
            }}
          >
            <RemoteParticipants
              ref={videoRemoteRef}
              autoPlay={true}
              muted={false}
              style={
                !remoteVideoEnabled || reconnectingLocal || reconnectingRemote
                  ? { display: 'none' }
                  : { minWidth: '100%' }
              }
            />
            {!minimized && (
              <DurationTimerContainer>
                <PatientName>{doctorName}</PatientName>
                <DurationTimer>
                  {formatTime(minutes)}:{formatTime(seconds)}
                </DurationTimer>
              </DurationTimerContainer>
            )}
            {minimized && !remoteAudioEnabled && (
              <AudioMuted
                src={mute}
                style={{ height: '30px', width: '30px', bottom: '10%' }}
              />
            )}
            {minimized && (reconnectingLocal || reconnectingRemote) && (
              <PipReconContainer>
                <ConnectingGif
                  src={reconnectGif}
                  style={{ height: '50px', width: '50px' }}
                />
              </PipReconContainer>
            )}
            {!remoteVideoEnabled &&
              !reconnectingLocal &&
              !reconnectingRemote && (
                <VideoDisabledContainer>
                  <div
                    style={
                      !minimized
                        ? {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'var(--primary-button)',
                            borderRadius: '100%',
                            padding: '43px',
                            width: '150px',
                            height: '150px',
                          }
                        : {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'var(--primary-button)',
                            borderRadius: '100%',
                            padding: '43px',
                            width: '100px',
                            height: '100px',
                          }
                    }
                  >
                    <PatientInitials>
                      {extractFirstLetter(doctorName).toUpperCase()}
                    </PatientInitials>
                  </div>
                </VideoDisabledContainer>
              )}
          </div>
        ) : (
          <RemoteParticipantsImg
            src={waitingRoom}
            style={
              reconnectingLocal || reconnectingRemote || badNetwork || minimized
                ? { display: 'none' }
                : { width: '100%' }
            }
          />
        ))}
      {!connecting &&
        !callEnded &&
        userConnected &&
        (!minimized ? (
          <Minimize src={maximize} onClick={() => handleMinimize()} />
        ) : (
          <Maximize src={maximize} onClick={() => handleMinimize()} />
        ))}
      {!connecting && !callEnded && !minimized && (
        <>
          <NetworkBarContainer>
            {networkQualityLocal === 1 && <NetworkBar src={bar1} />}
            {networkQualityLocal === 2 && <NetworkBar src={bar2} />}
            {networkQualityLocal === 3 && <NetworkBar src={bar3} />}
            {networkQualityLocal === 4 && <NetworkBar src={bar4} />}
            {networkQualityLocal === 5 && <NetworkBar src={bar5} />}
            {networkQualityLocal >= 1 && (
              <NetworkBarText>Patient</NetworkBarText>
            )}
          </NetworkBarContainer>
          <NetworkBarContainer style={{ right: '15px' }}>
            {networkQualityRemote === 1 && <NetworkBar src={bar1} />}
            {networkQualityRemote === 2 && <NetworkBar src={bar2} />}
            {networkQualityRemote === 3 && <NetworkBar src={bar3} />}
            {networkQualityRemote === 4 && <NetworkBar src={bar4} />}
            {networkQualityRemote === 5 && <NetworkBar src={bar5} />}
            {networkQualityRemote >= 1 && (
              <NetworkBarText>Doctor</NetworkBarText>
            )}
          </NetworkBarContainer>
        </>
      )}
      {callEnded && (
        <ConnectionContainer>
          <ConnectingContainer style={{ padding: '0px' }}>
            <ConnectingGif
              src="https://tinyurl.com/tc844ayc"
              style={{ height: '210px', width: '210px', marginTop: '-15px' }}
            />
            <ConnectingText style={{ marginTop: '-35px' }}>
              Call Ended
            </ConnectingText>
            <ConnectingText style={{ fontSize: '12px', marginTop: '15px' }}>
              Duration: 05:08
            </ConnectingText>
          </ConnectingContainer>
        </ConnectionContainer>
      )}
      {!connecting &&
        !minimized &&
        localUserConnected &&
        poorConnectionModal &&
        !reconnectingLocal &&
        !reconnectingRemote && (
          <PoorConnectionContainer>
            <NetworkBar src={bar1} />
            <PoorConnectionTextContainer>
              <PoorConnectionText>Poor Connection</PoorConnectionText>
              <PoorConnectionText
                style={{ fontSize: '12px', fontWeight: '400' }}
              >
                Try moving to get better signal
              </PoorConnectionText>
            </PoorConnectionTextContainer>
            <FaTimes
              style={{ height: '24px', width: '24px', color: '#FFF' }}
              onClick={() => setPoorConnectionModal(false)}
            />
          </PoorConnectionContainer>
        )}
      {!connecting && !minimized && (
        <ControlsContainer>
          <Controls onClick={() => handleMuteVideo()} speaker={!muteVideo}>
            {muteVideo ? (
              <ControlsImg src={videoOff} />
            ) : (
              <ControlsImg src={videoOn} />
            )}
          </Controls>
          <Controls onClick={() => handleMuteAudio()} mute={!muteAudio}>
            {muteAudio ? (
              <ControlsImg src={mute} />
            ) : (
              <ControlsImg src={muteActive} />
            )}
          </Controls>
          <Controls endCall={true} onClick={() => handleDisconnectRoom()}>
            <FaTimes style={{ height: '30px', width: '30px', color: '#FFF' }} />
          </Controls>
          {videoDevices.length > 1 && (
            <Controls
              onClick={toggleCamera}
              disabled={isSwitchingCamera}
              style={{
                opacity: isSwitchingCamera ? 0.6 : 1,
                position: 'relative',
              }}
            >
              {isSwitchingCamera ? (
                // Loading spinner overlay
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    borderRadius: '50%',
                  }}
                >
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      border: '2px solid #ffffff',
                      borderTopColor: 'transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                    }}
                  />
                </div>
              ) : (
                <ControlsImg src={switchCameraIcon} />
              )}
            </Controls>
          )}
        </ControlsContainer>
      )}
      {!connecting &&
        !minimized &&
        userConnected &&
        !remoteAudioEnabled &&
        !badNetwork &&
        !reconnectingLocal &&
        !reconnectingRemote && (
          <AudioMuted
            src={mute}
            poorConn={poorConnectionModal}
            minimized={minimized}
          />
        )}
      {/* {
        minimized && (<ConsultContainerMinimized />)
      } */}
    </OuterContainer>
  );
};

export default VideoRoom;
